var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#087F5B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.558 14.5L6.55 5.74H7.582L8.242 12.22C8.258 12.396 8.274 12.58 8.29 12.772C8.306 12.956 8.318 13.132 8.326 13.3C8.342 13.468 8.35 13.608 8.35 13.72C8.366 13.608 8.378 13.468 8.386 13.3C8.402 13.132 8.418 12.956 8.434 12.772C8.458 12.58 8.482 12.396 8.506 12.22L9.322 5.74H10.438L11.182 12.22C11.206 12.396 11.226 12.58 11.242 12.772C11.266 12.956 11.286 13.132 11.302 13.3C11.326 13.468 11.342 13.608 11.35 13.72C11.358 13.608 11.366 13.468 11.374 13.3C11.39 13.132 11.406 12.956 11.422 12.772C11.446 12.58 11.466 12.396 11.482 12.22L12.166 5.74H13.15L12.118 14.5H10.762L10.018 7.9C10.002 7.716 9.982 7.536 9.958 7.36C9.942 7.184 9.926 7.02 9.91 6.868C9.894 6.716 9.882 6.592 9.874 6.496C9.866 6.592 9.85 6.716 9.826 6.868C9.81 7.02 9.794 7.184 9.778 7.36C9.762 7.536 9.742 7.716 9.718 7.9L8.914 14.5H7.558Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWon);
export default __webpack_public_path__ + "static/media/won.31be6d3d763e95277dcf2aa843e195f5.svg";
export { ForwardRef as ReactComponent };